import { useNavigate, useParams } from "react-router-dom";
import { useGetOneByIdQuery, useUpdateMutation } from "../../features/api/Api";
import { useLocales } from "../../hooks";
import Swal from "sweetalert2";
import { saveHandler } from "../../handlers";
import { isExists } from "../../utils";
import { Form, Formik } from "formik";
import { Divider, Grid } from "@mui/material";
import {
  IndividualHandler,
  SetIndividualHandler,
} from "../applications/common";
import {
  CheckboxInput,
  FormFooter,
  ReferenceDropDown,
  TextInput,
} from "../../components";
import {
  ContactInfoArray,
  IsAuthorizedSignature,
  KvkkInputs,
} from "../applications/contact/common";
import LegalPermissionStatus from "../applications/contact/common/LegalPermissonStatus";

export default function CustomerRelatedPersonDetail() {
  const [update] = useUpdateMutation();
  const history = useNavigate();
  const { translate } = useLocales();
  const { contactId } = useParams();
  const { customerId } = useParams();
  const { data: contact } = useGetOneByIdQuery<any>({
    resource: `fixity/customer/contact`,
    id: contactId,
  });

  const updateMethod = (values: any, { setSubmitting }: any) => {
    update({ resource: `fixity/customer/contact `, params: values })
      .unwrap()
      .then(() => {
        Swal.fire(translate("actions.saved"), "", "success");
        setSubmitting(false);
        history(`/applications/${customerId}/related_person/${contactId}/edit`);
      });
  };
  function submitHandler(values: any, { setSubmitting }: any) {
    saveHandler(values, { setSubmitting }, updateMethod);
  }
  return (
    <div>
      {isExists(contact?.data) ? (
        <Formik initialValues={{ ...contact?.data }} onSubmit={submitHandler}>
          {(props: any) => (
            <Form>
              <Grid container spacing={3}>
                <IndividualHandler />
                <SetIndividualHandler />
                <Grid item md={12}>
                  <CheckboxInput
                    name="isAuthorizedPerson"
                    label={translate(
                      "resources.customers.related_persons.isAuthorizedPerson"
                    )}
                    disabled={true}
                  />
                  <IsAuthorizedSignature
                    name="isAuthorizedSignature"
                    customerTypeId={props.values.customerTypeId}
                    customerKindId={props.values.customerKindId}
                  />
                  <Divider />
                </Grid>
                <Grid item md={6}>
                  <TextInput
                    name="name"
                    label={translate(
                      "resources.customers.related_persons.name"
                    )}
                    disabled={true}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextInput
                    name="surname"
                    label={translate(
                      "resources.customers.related_persons.surname"
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item md={6}>
                  <ReferenceDropDown
                    name="jobTitleId"
                    label={translate(
                      "resources.customers.related_persons.jobTitle"
                    )}
                    reference="fixity/customer/jobTitle"
                    optionName="name"
                    disabled={true}
                  />
                </Grid>
                <Grid item md={6}>
                  <ReferenceDropDown
                    name="departmentId"
                    label={translate(
                      "resources.customers.related_persons.department"
                    )}
                    reference="fixity/customer/department"
                    optionName="name"
                    disabled={true}
                  />
                </Grid>

                <Grid item md={12}>
                  <LegalPermissionStatus
                    legalPermission={props.values.legalPermission}
                  />
                  <Divider />
                  <KvkkInputs
                    kvkkMarkApprovalMailSend="kvkkMarkApprovalMailSend"
                    kvkkMarkApprovalSmsSend="kvkkMarkApprovalSmsSend"
                    customerTypeId={props.values.customerTypeId}
                  />
                  <Divider />
                </Grid>

                <Grid item md={12}>
                  <Grid container spacing={4}>
                    <ContactInfoArray
                      contactCommunication="contactCommunication"
                      contactCommunicationValue={
                        props.values.contactCommunication
                      }
                      disabled={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <FormFooter>{/* <EditButton disabled={false} /> */}</FormFooter>
            </Form>
          )}
        </Formik>
      ) : null}
    </div>
  );
}
